export default __webpack_public_path__ + "static/media/The_Impostor.8edbb3f7.ttf";